export default __webpack_public_path__ + "static/media/FGCoop-light.eed54965.svg";